import MxDetailLayoutMain from "@rf-l1/page/details/MxDetailLayoutMain";
import MxLoading from "@rf-l1/loading/MxLoading";
import MxEmptyBody from "@rf-l1/empty-sections/MxEmptyBody";
import MxEmptyIcon from "@rf-l1/empty-sections/MxEmptyIcon";
import MxEmptyCard from "@rf-l1/empty-sections/MxEmptyCard";
import { MxRenderDetailTemplate } from "@rf-l1/page/details/MxRenderDetailTemplate";
import { useLoaderPropertyDetailPage } from "./hook/useLoaderPropertyDetailPage";
import { PropertyDetailPageProvider } from "./context/PropertyDetailPageContext";
import MainDetail from "./components/main-detail/MainDetail";

import { Box, Grid, IconButton, styled } from "@mui/material";
import { createPortal } from "react-dom";
import { useWidth } from "@/shared/hooks/use-width.hook";
import BackIcon from "@icons-rf/property-panel/arrow-back.svg?react";
import PropertyDetailChangeLog from "./components/change-log/PropertyDetailChangeLog";
import PropertyDataLog from "./components/data-log/PropertyDataLog";
import VirtualTour from "./components/virtual-tour/VirtualTour";
import DetailPropertyProjectTable from "./components/project-table/DetailPropertyProjectTable";
import MxYouTubeVideos from "./components/youtube-videos/MxYouTubeVideos";
import VirtualFolders from "./components/virtual-folders/VirtualFolders";
import PropertyActionsPanel from "./components/actions-panel/PropertyActionsPanel";
import PropertyAgentsCard from "./components/agents-card/PropertyAgentsCard";
import PropertyOwnersCard from "./components/owners-card/PropertyOwnersCard";
import PropertyStatisticsCard from "./components/statistics-card/PropertyStatisticsCard";
import PropertyProfessionalFeesCard from "./components/professional-fees-card/PropertyProfessionalFeesCard";
import PropertyWarningsCard from "./components/warnings-card/PropertyWarningsCard";
import PropertyDocumentsCard from "./components/documents-card/PropertyDocumentsCard";
import PropertyValidationDocumentsCard from "./components/validation-documents-card/PropertyValidationDocumentsCard";
import PropertyAlterestateCard from "./components/alterestate-card/PropertyAlterestateCard";
import usePropertyFeedback from "./hook/usePropertyFeedback";
import PropertyDetailRemaxGlobalCard from "./components/remax-global/PropertyDetailRemaxGlobalCard";

const PropertyDetailPage = () => {
  const { data, status } = useLoaderPropertyDetailPage();

  return (
    <MxRenderDetailTemplate
      data={Boolean(data)}
      status={status}
      template={
        <MxDetailLayoutMain>
          <PropertyDetailPageProvider initialData={data!}>
            <PropertyDetailContent />
          </PropertyDetailPageProvider>
        </MxDetailLayoutMain>
      }
      errorTemplate={
        <MxEmptyCard size="page">
          <MxEmptyIcon variant="error" />
          <MxEmptyBody>
            Ah ocurrido un inconveniente o la propiedad no fue encontrada
          </MxEmptyBody>
        </MxEmptyCard>
      }
      loadingTemplate={
        <MxEmptyCard size="page">
          <MxLoading variant="gradient" />
        </MxEmptyCard>
      }
      emptyTemplate={
        <MxEmptyCard size="page">
          <MxEmptyIcon variant="404" />
          <MxEmptyBody>la propiedad no fue encontrada</MxEmptyBody>
        </MxEmptyCard>
      }
    />
  );
};

const BackButton = styled(IconButton)`
  top: 10px;
  left: 10px;
`;

const NavBarButton = styled(Box)`
  position: relative;
  width: 25px;
  height: 25px;
  top: -15px;
  z-index: 10001;
  & .MuiButtonBase-root {
    background-color: var(--m-color-blue-03);
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;

    &:hover {
      background-color: var(--m-color-blue-03);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    }

    svg {
      color: white;
      width: 20px;
      height: 20px;
    }
  }
`;

const PropertyDetailContent = () => {
  // Initialize feedback hook to handle automatic modal display
  usePropertyFeedback();

  const width = useWidth();
  const isMobile = ["xs", "sm"].includes(width);

  return (
    <>
      {!isMobile &&
        (() => {
          const toolBar =
            typeof document !== "undefined"
              ? document.getElementById("tool-bar")
              : null;
          return toolBar
            ? createPortal(
                <NavBarButton>
                  <BackButton
                    disableRipple
                    onClick={() => window.close()}
                    size="small"
                  >
                    <BackIcon />
                  </BackButton>
                </NavBarButton>,
                toolBar
              )
            : null;
        })()}

      <Grid container spacing={2}>
        <Grid container item xs={12} md={8} rowGap={2} alignItems="flex-start">
          <MainDetail />

          <VirtualTour />

          <DetailPropertyProjectTable />

          <MxYouTubeVideos />

          <VirtualFolders />

          <PropertyDataLog />

          <PropertyDetailChangeLog />
        </Grid>

        <Grid container item xs={12} md={4} rowGap={2} alignSelf="flex-start">
          <PropertyActionsPanel />
          <PropertyWarningsCard />
          <PropertyAgentsCard />
          <PropertyDetailRemaxGlobalCard />
          <PropertyOwnersCard />
          <PropertyStatisticsCard />
          <PropertyProfessionalFeesCard />
          <PropertyDocumentsCard />
          <PropertyValidationDocumentsCard />
          <PropertyAlterestateCard />
        </Grid>
      </Grid>
    </>
  );
};

export default PropertyDetailPage;
